import * as t from 'io-ts';
import { StaffAccountBasicDataType } from 'src/AppState/sdk/staff';
import { createGuard } from 'src_common/common/createGuard';

/* Billing info start */


export interface BillingInfoData {
    email: string | undefined,
    prefix: string | undefined,
    number: string | undefined,
    addressLine1: string | undefined,
    addressLine2: string | undefined,
    city: string | undefined,
    country: string | undefined,
    postCode: string | undefined,
}

export interface BillingInfoError {
    type: 'error',
    fieldsRequired: string[],
    data: BillingInfoData
}

export interface BillingInfoSuccess {
    type: 'ok'
    data: {
        email: string,
        prefix: string,
        number: string,
        addressLine1: string,
        addressLine2: string | undefined,
        city: string,
        country: string,
        postCode: string | undefined,
    }
}

const isCorrectData = createGuard(
    t.interface({
        email: t.string,
        prefix: t.string,
        number: t.string,
        addressLine1: t.string,
        city: t.string,
        country: t.string,
    })
);

const isParsedError = (value: string | undefined | null): boolean => {
    if (value === undefined || value === null || value.trim() === '') {
        return true;
    }

    return false;
};

export const billingInfoFields = (customerDetails: /*CustomerDetailsType |*/ StaffAccountBasicDataType): BillingInfoError | BillingInfoSuccess => {
    const { email, mobilePhone, addressLine1, addressLine2, city, country, postCode } = customerDetails;

    const dataNotValidated = {
        addressLine2: addressLine2 ?? undefined,
        postCode: postCode ?? undefined
    };

    const dataToValid = {
        email: email ?? undefined,
        prefix: mobilePhone?.prefix ?? undefined,
        number: mobilePhone?.number ?? undefined,
        addressLine1: addressLine1 ?? undefined,
        city: city ?? undefined,
        country: country ?? undefined,
    };

    if (isCorrectData(dataToValid)) {

        return {
            type: 'ok',
            data: { ...dataToValid, ...dataNotValidated }
        };
    }

    const fieldsRequired: Array<string> = [];

    if (isParsedError(dataToValid['email'])) {
        fieldsRequired.push('email');
    }
    if (isParsedError(dataToValid['prefix'])) {
        fieldsRequired.push('prefix phone number');
    }
    if (isParsedError(dataToValid['number'])) {
        fieldsRequired.push('phone number');
    }
    if (isParsedError(dataToValid['addressLine1'])) {
        fieldsRequired.push('address');
    }
    if (isParsedError(dataToValid['city'])) {
        fieldsRequired.push('city');
    }
    if (isParsedError(dataToValid['country'])) {
        fieldsRequired.push('country');
    }
    return {
        type: 'error',
        fieldsRequired,
        data: { ...dataToValid, ...dataNotValidated }
    };

};

/* Billing info end */


/* Realex(GlobalPayments) iframe messageData and response handling start */
/* partially use for Secure Trading(Trust Payments) */
export interface MessageData {
    action: string,
    id: string,
    reason: 'declined' | 'referral-a' | 'referral-b' | 'comms-error',
    type: 'success' | 'error',
    error: string
}

export type SetDepositFinalViewProps = 'errorIframe' | 'success' | 'declined';

/* Realex(GlobalPayments) iframe messageData and response handling end */


